// extracted by mini-css-extract-plugin
module.exports = {"fullScreenClose":"style__fullScreenClose___3ulIk"};